const MODULE_RELOAD_KEY = "kelasai_module_reload_attempt";
const RETRY_WINDOW_MS = 30_000;

const MODULE_ERROR_PATTERNS = [
  "Importing a module script failed",
  "Failed to fetch dynamically imported module",
  "error loading dynamically imported module",
  "Loading chunk",
  "Loading CSS chunk",
  "ChunkLoadError",
];

const getMessage = (value: unknown): string => {
  if (!value) return "";
  if (value instanceof Error) return value.message || value.name || "";
  if (typeof value === "string") return value;
  if (typeof value === "object" && "message" in value) {
    return String((value as { message?: unknown }).message ?? "");
  }
  return "";
};

export const isModuleLoadError = (value: unknown) => {
  const message = getMessage(value);
  return MODULE_ERROR_PATTERNS.some((pattern) => message.includes(pattern));
};

export const reloadForModuleLoadFailure = () => {
  try {
    const now = Date.now();
    const previous = sessionStorage.getItem(MODULE_RELOAD_KEY);
    const currentPath = `${window.location.pathname}${window.location.search}`;

    if (previous) {
      const { path, time } = JSON.parse(previous) as { path?: string; time?: number };
      if (path === currentPath && time && now - time < RETRY_WINDOW_MS) {
        return false;
      }
    }

    sessionStorage.setItem(MODULE_RELOAD_KEY, JSON.stringify({ path: currentPath, time: now }));
    const url = new URL(window.location.href);
    url.searchParams.set("__module_reload", String(now));
    window.location.replace(url.toString());
    return true;
  } catch {
    window.location.reload();
    return true;
  }
};

export const installModuleLoadRecovery = () => {
  window.addEventListener("vite:preloadError", ((event: Event & { payload?: unknown }) => {
    event.preventDefault?.();
    reloadForModuleLoadFailure();
  }) as EventListener);

  window.addEventListener("unhandledrejection", (event) => {
    if (isModuleLoadError(event.reason)) {
      event.preventDefault();
      reloadForModuleLoadFailure();
    }
  });

  window.addEventListener(
    "error",
    (event) => {
      const target = event.target as HTMLElement | null;
      const failedModuleScript = target?.tagName === "SCRIPT" && (target as HTMLScriptElement).type === "module";

      if (failedModuleScript || isModuleLoadError(event.error) || isModuleLoadError(event.message)) {
        event.preventDefault();
        reloadForModuleLoadFailure();
      }
    },
    true
  );

  window.setTimeout(() => {
    try {
      sessionStorage.removeItem(MODULE_RELOAD_KEY);
      const url = new URL(window.location.href);
      if (url.searchParams.has("__module_reload")) {
        url.searchParams.delete("__module_reload");
        window.history.replaceState(window.history.state, "", url.toString());
      }
    } catch {
      // no-op
    }
  }, 8_000);
};